module.exports = __webpack_public_path__ + "static/feature_graphic.37fe648f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/feature_graphic.jpg
// module id = 1162
// module chunks = 35783957827783